const cards = [
    {
        owner: {
            pk: 2,
            username: 'Mock User',
        },
        title: 'Test Card 1',
        outer_message: 'Hello World!',
        inner_message: 'Goodbye World!',
        pk: 1,
    },
    {
        owner: {
            pk: 1,
            username: 'root',
        },
        title: 'Test Card 2',
        outer_message: 'foo',
        inner_message: 'bar',
        pk: 2,
    },
    {
        owner: {
            pk: 3,
            username: 'Jebediah Kerman',
        },
        title: 'Test Card 3',
        outer_message: 'baz',
        inner_message: 'asdf',
        pk: 3,
    },
]

export {cards}
